import React, { useContext } from 'react';
import { ConfigContext } from '../../context/Config';
import Text from '../Text/Text';
import DateViewer from '../DateViewer/DateViewer';
import TimeViewer from '../TimeViewer/TimeViewer';
import Avatar from '../Avatar/Avatar';
import isEmpty from 'lodash/isEmpty';
import PracticeActions from '../PracticeActions';
import Wrapper from '../Wrapper';
import Button from '../Button';
import './CalendarDashboardEvent.less';

export type Attendee = {
  id?: string;
  name: string;
  avatar?: string;
};

export type Event = {
  id?: string;
  title: string;
  eventStartDate: string;
  eventEndDate: string;
  attendees: Attendee[];
  meetingLinks?: { [key: string]: string };
  altLink?: string;
  color?: string;
  type?: 'event' | 'booking';
  viewTitle?: string;
  lessonsCount?: any;
};

export type CalendarDashboardEventProps = Event & {
  locale?: string;
  titleColor?: 'black';
  avatarTextColor?: 'black';
  onItemClick?: (item: any) => void;
  onBook?: (item: any) => void;
};

const TCalendarDashboardEvent: React.FC<CalendarDashboardEventProps> = ({
  title,
  eventStartDate,
  eventEndDate,
  attendees = [],
  meetingLinks,
  altLink,
  type = 'event',
  locale,
  titleColor,
  avatarTextColor,
  viewTitle,
  onItemClick,
  onBook,
  lessonsCount,
}) => {
  const { translate } = useContext(ConfigContext);

  const link =
    !isEmpty(meetingLinks) &&
    !!Object.values(meetingLinks)[0] &&
    Object.values(meetingLinks)[0];

  return (
    <div className="t-calendarListItem" onClick={onItemClick}>
      <div className="t-infoContainer">
        <div className="t-dateContainer">
          <DateViewer locale={locale} date={eventStartDate} />
        </div>
        <div className="t-titleAndImages">
          <Text
            textColor={titleColor}
            level={2}
            rows={1}
            bold
            paddingBottom={2}
          >
            {viewTitle || title}
          </Text>
          {attendees.map((item) => (
            <div className="t-avatarGroup">
              <Avatar src={item?.avatar} name={item?.name} size="xs" />
              <div className="t-avatar-text">
                <Text textColor={avatarTextColor} level={3}>
                  {item?.name}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="t-timeAndEvents">
        <Wrapper mb={2}>
          <TimeViewer
            locale={locale}
            start={eventStartDate}
            end={eventEndDate}
          />
        </Wrapper>
        {!!lessonsCount && (
          <Text rows={1} level={3} textColor="primary">
            <>{translate('ui.lessons.count')} - </>
            {lessonsCount || 0}
          </Text>
        )}
        {type === 'booking' && (
          <Button onClick={onBook}>{translate('ui.book')}</Button>
        )}
        {type !== 'booking' && (
          <PracticeActions trainingLink={link} practiceLink={altLink} />
        )}
      </div>
    </div>
  );
};

export default TCalendarDashboardEvent;
